import { OptionModel } from "model/Option.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = OptionModel[];

export const useDefaultObservableOptionModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectOptionModelArray extends BehaviorSubject<CurrentType> {}
